"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.delay = (ms) => new Promise(res => setTimeout(res, ms));
function using(resource, func) {
    try {
        func(resource);
    }
    finally {
        resource.dispose();
    }
}
exports.using = using;
function isNonEmpty(str) {
    if (!str)
        return false;
    return str.length > 0;
}
exports.isNonEmpty = isNonEmpty;
function isNullOrEmpty(str) {
    if (!str)
        return true;
    return str.length === 0;
}
exports.isNullOrEmpty = isNullOrEmpty;
function isJson(jsonStr) {
    if (!jsonStr)
        return false;
    try {
        const jsonObj = JSON.parse(jsonStr);
        return jsonObj ? true : false;
    }
    catch (_a) {
        return false;
    }
}
exports.isJson = isJson;
function parseJsonString(jsonStr) {
    try {
        const jsonObj = JSON.parse(jsonStr);
        return jsonObj;
    }
    catch (_a) {
        return jsonStr;
    }
}
exports.parseJsonString = parseJsonString;
// export type Tuple2<T1, T2> = {
//   Item1: T1,
//   Item2: T2,
// }
class Tuple2 {
    constructor(para) {
        this.Item1 = null;
        this.Item2 = null;
        this.Item1 = para.Item1 || this.Item1;
        this.Item2 = para.Item2 || this.Item2;
    }
}
exports.Tuple2 = Tuple2;
function NewTuple2(t1, t2) {
    return new Tuple2({
        Item1: t1,
        Item2: t2,
    });
}
exports.NewTuple2 = NewTuple2;
class Tuple3 {
    constructor(para) {
        this.Item1 = null;
        this.Item2 = null;
        this.Item3 = null;
        this.Item1 = para.Item1 || this.Item1;
        this.Item2 = para.Item2 || this.Item2;
        this.Item3 = para.Item3 || this.Item3;
    }
}
exports.Tuple3 = Tuple3;
function NewTuple3(t1, t2, t3) {
    return new Tuple3({
        Item1: t1,
        Item2: t2,
        Item3: t3,
    });
}
exports.NewTuple3 = NewTuple3;
class Tuple4 {
    constructor(para) {
        this.Item1 = null;
        this.Item2 = null;
        this.Item3 = null;
        this.Item4 = null;
        this.Item1 = para.Item1 || this.Item1;
        this.Item2 = para.Item2 || this.Item2;
        this.Item3 = para.Item3 || this.Item3;
        this.Item4 = para.Item4 || this.Item4;
    }
}
exports.Tuple4 = Tuple4;
function NewTuple4(t1, t2, t3, t4) {
    return new Tuple4({
        Item1: t1,
        Item2: t2,
        Item3: t3,
        Item4: t4,
    });
}
exports.NewTuple4 = NewTuple4;
class AsyncUtil {
    static async AsyncWaitUntil(endWaiting, timeout = 1000, checkingInterval = AsyncUtil.DEFAULT_CHECKING_INTERVAL, callerMemberName = "") {
        const waittingInterval = checkingInterval > 0 ? checkingInterval : AsyncUtil.DEFAULT_CHECKING_INTERVAL;
        let waitedTime = 0;
        while (!endWaiting()) {
            if (waitedTime >= timeout) {
                console.warn(`Waited ${waitedTime}ms > timeout=${timeout}, force end waiting.`, callerMemberName);
                return;
            }
            await exports.delay(waittingInterval);
            waitedTime += waittingInterval;
        }
        console.debug(`Waiting completed, took ${waitedTime}ms`, callerMemberName);
    }
    static async AsyncWaitUntilOverload1(endWaiting, timeout = 1000, checkingInterval = AsyncUtil.DEFAULT_CHECKING_INTERVAL, callerMemberName = "") {
        const waittingInterval = checkingInterval > 0 ? checkingInterval : AsyncUtil.DEFAULT_CHECKING_INTERVAL;
        let waitedTime = 0;
        while (!await endWaiting()) {
            if (waitedTime >= timeout) {
                console.warn(`Waited ${waitedTime}ms > timeout=${timeout}, force end waiting.`, callerMemberName);
                return;
            }
            await exports.delay(waittingInterval);
            waitedTime += waittingInterval;
        }
        console.debug(`Waiting completed, took ${waitedTime}ms`, callerMemberName);
    }
}
AsyncUtil.DEFAULT_CHECKING_INTERVAL = 500;
exports.AsyncUtil = AsyncUtil;
function iterableObjToTypedArray(iterableObj, ctor) {
    //if (!Array.isArray(objArray)) throw Error(`objArray={oAy} is not array`);
    const outAy = [];
    for (const i of iterableObj) {
        if (!ctor)
            outAy.push(i);
        else
            outAy.push(new ctor(i));
    }
    return outAy;
}
exports.iterableObjToTypedArray = iterableObjToTypedArray;
function iterableObjToTypedSet(iterableObj, ctor) {
    //if (!Array.isArray(objArray)) throw Error(`objArray={oAy} is not array`);
    const outSet = new Set();
    for (const i of iterableObj) {
        if (!ctor)
            outSet.add(i);
        else
            outSet.add(new ctor(i));
    }
    return outSet;
}
exports.iterableObjToTypedSet = iterableObjToTypedSet;
function objectToStringKeyTypedValueMap(aObj, ctor) {
    if (typeof aObj !== "object")
        throw Error(`aObj={aObj} is not a object.`);
    const aMap = new Map();
    if (aObj instanceof Map) {
        for (const key of aObj.keys()) {
            if (!ctor)
                aMap.set(key, aObj.get(key));
            else
                aMap.set(key, new ctor(aObj.get(key)));
        }
    }
    else {
        for (const key in aObj) {
            if (!ctor)
                aMap.set(key, aObj[key]);
            else
                aMap.set(key, new ctor(aObj[key]));
        }
    }
    return aMap;
}
exports.objectToStringKeyTypedValueMap = objectToStringKeyTypedValueMap;
/**
 *
 * Convert object to Map<K,V>
 *
 * @export
 * @template K Generic parameter K needs to have equals() & toString()
 * @template V
 * @param {object} aObj need to be converted object
 * @param {{ kctor?: new(k: K) => K, vctor?: new(v: V) => V }} kctor:key's constructor, vctor: value's constructor.
 * @returns {Map<K, V>}
 */
function objectToTypedKTypedVMap(aObj, ctor) {
    if (typeof aObj !== "object")
        throw Error(`aObj={aObj} is not a object.`);
    const aMap = new Map();
    if (aObj instanceof Map) {
        for (const key of aObj.keys()) {
            const typedKey = ctor && ctor.kctor ? new ctor.kctor(key) : key;
            const value = aObj.get(key);
            const typedValue = ctor && ctor.vctor ? new ctor.vctor(value) : value;
            aMap.set(typedKey, typedValue);
        }
    }
    else {
        for (const key in aObj) {
            const parsedKey = isJson(key) ? JSON.parse(key) : key;
            const typedKey1 = ctor && ctor.kctor ? new ctor.kctor(parsedKey) : parsedKey;
            const value1 = aObj[key];
            const typedValue1 = ctor && ctor.vctor ? new ctor.vctor(value1) : value1;
            aMap.set(typedKey1, typedValue1);
        }
    }
    return aMap;
}
exports.objectToTypedKTypedVMap = objectToTypedKTypedVMap;
//# sourceMappingURL=TypeScriptUtils.js.map